import { render, staticRenderFns } from "./FavoriteCourses.vue?vue&type=template&id=537cf122&"
import script from "./FavoriteCourses.vue?vue&type=script&lang=js&"
export * from "./FavoriteCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports